module.exports = __webpack_public_path__ + "static/media/2lashfiler.602b93f8.png";